import { lazy } from 'react';
import { Typography } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import * as locationApi from '../../services/locationApi';

const LocationForm = lazy(() => import('./LocationForm'));
const LocationView = lazy(() => import('./LocationView'));

export const locationConfig = {
  id: 'locations',
  resourceType: 'location',
  singularName: 'Location',
  pluralName: 'Locations',
  icon: PlaceIcon,
  searchable: true,
  modalSize: 'md',
  getDisplayName: (item) => item.name || '',
  renderDisplayName: (item) => (
    <Typography component="span" variant="body1" color="primary" sx={{ '&:hover': { textDecoration: 'underline' } }}>
      {item.name || ''}
    </Typography>
  ),
  sortOptions: [
    {
      label: 'Sort by Name',
      value: 'name',
      sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
    },
    {
      label: 'Sort by Feature Count',
      value: 'feature_count',
      sorter: (a, b, additionalProps) => {
        const countB = b.feature_ids?.length || 0;
        const countA = a.feature_ids?.length || 0;
        if (countB !== countA) {
          return countB - countA;
        }
        return (a.name || '').localeCompare(b.name || '');
      },
    },
  ],
  getInitialState: (data) => ({
    id: data?.id || null,
    name: data?.name || '',
    description: data?.description || '',
    feature_ids: data?.feature_ids || [],
    shadows_id: data?.shadows_id || null,
    user_id: data?.user_id || null,
    _isPartial: data?._isPartial || false,
  }),
  api: {
    getAll: locationApi.getMyLocations,
    create: locationApi.createLocation,
    update: locationApi.updateLocation,
    delete: locationApi.deleteLocation,
    getById: locationApi.getMyLocations,
  },
  FormComponent: LocationForm,
  ViewComponent: LocationView,
};